<div class="px-xl pt-md">
  <ng-content></ng-content>
</div>
